import { cn } from './cn.js';
/**
 * The card surface the molecules share.
 *
 * Elevation 0 by default: a hairline border and no shadow, because
 * "separation is done with borders, surface contrast and spacing. Nothing
 * floats by default" (handoff, Elevation).
 *
 * Radius is `md`, which is 12px. The molecule prose quotes 16px for cards,
 * but tokens.css labels `--radius-md` as the card radius, and the handoff's
 * own tie-break is that the token bundle wins where the two disagree. Same
 * reasoning puts nav items and the search field on `sm` rather than the 10px
 * the prose mentions: tokens.css calls `--radius-sm` the control radius.
 */
export const CARD_SURFACE = 'rounded-md border border-border bg-surface';
/**
 * A bounded working panel: one region of a page that needs a visible boundary
 * — a form, a decision, a chart with its legend — with the padding every such
 * region uses, 16px on a phone and 24px from `sm`.
 *
 * One level. What sits inside a panel is flat: dividers, inset fills or plain
 * sections, never another panel or a card. A panel is not a page wrapper
 * either; the page itself is the canvas.
 */
export const PANEL_SURFACE = cn(CARD_SURFACE, 'p-4 sm:p-6');
/** Elevation 1, for a card that is itself a link or button. */
export const CARD_INTERACTIVE = cn('transition-[box-shadow,border-color]', 'hover:border-border-strong hover:shadow-elevation-1');
/** Elevation 2. Overlays only: dialogs, popovers, the profile menu. */
export const OVERLAY_SURFACE = 'rounded-md border border-border bg-surface shadow-elevation-2';
//# sourceMappingURL=surface-styles.js.map